import React, { useEffect, useState } from 'react';
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';
import { useDispatch } from 'react-redux';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';

const SkillSetMatrixReport = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Skillset Matrix"))
    }, [])

    const [listData, setListData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [skillId, setSkillId] = useState([]);
    const [subSkillId, setSubSkillId] = useState([]);
    const [emp, setEmp] = useState([]);

    const filters = {
        SkillId: 0,
        SkillSet: 0,
        empId: 0
    };
    const [filter, setFilter] = useState(filters);

    useEffect(() => {
        fetchSkillsetReport();
    }, [searchTerm]);


    const [apiStatus, setApiStatus] = useState(undefined)
    const fetchSkillsetReport = async () => {
        setApiStatus(undefined)
        try {
            const response = await GetServiceCaller(`${API_URL}rom-report/7?P_SkillID=${filter.SkillId}&P_SkillSet=${filter.SkillSet}&P_empID=${filter.empId}`);
            setApiStatus(response?.status)
            if (response?.status === 200) {
                setListData(response?.data?.header);

                const skill = response?.data?.skills.map((item) => ({
                    value: item.value,
                    label: item.text,
                }));
                skill.unshift({ value: 0, label: "Select..." });
                setSkillId(skill);
                const subSkill = response?.data?.
                    subskill.map((item) => ({
                        value: item?.ID,
                        label: item?.SubSkill,
                    }));
                skill.unshift({ value: 0, label: "Select..." });
                setSubSkillId(subSkill);


                const empp = response?.data?.employee.map((item) => ({
                    value: item?.value,
                    label: item?.text,
                }));
                empp.unshift({ value: 0, label: "Select..." });
                setEmp(empp);
            }
        } catch (error) {
            console.error("Fetching Api Error", error);

        }
    }


    const columns = {
        Code: { text: "EMP ID", align: "start",width:"60px", visible: true },
        EmpName: { text: "Employee", visible: true },
        skilldetails: { text: "Primary Skills", visible: true },
        secondaryskill: { text: "Secondary Skills", visible: true },
        ImmediateSuperior: { text: "Reporting Manager", visible: true },
        Remarks: { text: "Remarks", visible: true },
    }

    const formDatas = [
        {
            name: "Skill Set",
            type: "Select",
            options: [...skillId],
        },
        {
            name: "Sub Skill Set",
            type: "Select",
            options: [...subSkillId],
        },
        {
            name: "Employee List",
            type: "Select",
            options: [...emp],
        },

    ];

    const handleGetData = async () => {
        setApiStatus(undefined)
        try {
            const response =
                await GetServiceCaller(`${API_URL}rom-report/7?P_SkillID=${filterFormData.find((o) => o.label === "Skill Set")
                    ? filterFormData.find((o) => o.label === "Skill Set").value
                    : 0}&P_SkillSet=${filterFormData.find((o) => o.label === "Sub Skill Set")
                        ? filterFormData.find((o) => o.label === "Sub Skill Set").value
                        : 0}&P_empID=${filterFormData.find((o) => o.label === "Employee List")
                            ? filterFormData.find((o) => o.label === "Employee List")?.value
                            : 0}`);
            setApiStatus(response?.status)
            if (response.status === 200) {
                const cleanedData = response?.data?.header;
                setListData(cleanedData);
                // setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Customer Report Tracker. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Customer Report Tracker:", error);
        }
    };

    const [filterFormData, setFilterData] = useState([]);
    const handleChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };



    const handleReset = () => {
        setFilterData([])
        fetchSkillsetReport()
    }


    return (
        <>
            <div className="container-fluid" id="skill_section">
                <div className="container-fluid" id="skill-table-area">
                    <div className="row">
                        <Dynamic_PR_table
                            data={listData}
                            columns={columns}
                            isRequiredStatus={true}
                            isApiStatus={apiStatus}
                            handleReset={handleReset}
                            itemsPerPage={8}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            formDatas={formDatas}
                            filterFormData={filterFormData}
                            handleGetData={handleGetData}
                            isSorting={true}
                            isFilterRequired={true}
                            isCheckBoxRequired={false}
                            handleChange={handleChange}
                            add
                            more
                            function
                        />
                    </div>
                </div>
            </div>

        </>
    )
}

export default SkillSetMatrixReport